export const getTaggingId = (base: string, elementId: string) => `${base}_${elementId}`
export const getTaggingIdWithBase =
  (base: string) =>
  (...args: string[]) => {
    const formattedBase = base.replace(/[\s-]+/g, '_').toLowerCase()
    const formattedArgs = args.map((arg) => arg.replace(/&/g, 'and').replace(/[\s-]+/g, '_').toLowerCase()).join('_')
    return getTaggingId(formattedBase, formattedArgs)
  }
